<template>
    <span>
        <b-button @click="showDialog">{{$t('newBook.button')}}</b-button>
        <b-modal v-model="dialogVisible" :title="$t('newBook.title')"
                :cancel-title="$t('newBook.buttons.cancel')" :ok-disabled="$v.$invalid | saving" @ok="createBook"
                no-close-on-backdrop :no-close-on-esc="saving" :cancel-disabled="saving">
            <template v-slot:modal-ok>
                 {{$t('newEntry.buttons.ok')}}
                <font-awesome-icon v-if="saving" spin icon="spinner-third"></font-awesome-icon>
            </template>
            <p v-html="$t('newBook.instructions')"></p>
            <b-form-group :label="$t('newBook.label')">
                <b-input v-model.trim="bookName" :placeholder="$t('newBook.placeholder')"
                        :state="!$v.bookName.$invalid">></b-input>
                <b-form-invalid-feedback v-html="feedback"></b-form-invalid-feedback>
            </b-form-group>
        </b-modal>
    </span>

</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators';

const bookValidator = (value, vm) => {
  console.log('validator', value, vm);
  return !vm.scopes.filter(s => {
    return !(s.standard || (s.owner.localeCompare(vm.$store.state.username, 'en', { sensitivity: 'base' }) !== 0));
  })
    .find(s => {
      console.log(s.name, value, s.name.localeCompare(value, 'en', { sensitivity: 'accent' }));
      return s.name.localeCompare(value, 'en', { sensitivity: 'base' }) === 0;
    });
};

export default {
  name: 'newAddrBook',
  data: function() {
    return {
      dialogVisible: false,
      bookName: '',
      saving: false
    };
  },
  props: {
    scopes: Array
  },
  validations: {
    bookName: {
      required,
      maxLength: maxLength(50),
      bookValidator
    }
  },
  methods: {
    showDialog() {
      this.bookName = '';
      this.dialogVisible = true;
    },
    createBook(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.saving = true;

      this.$store.dispatch('createAddrBook', { name: this.bookName })
        .then(d => {
          this.$emit('newScope', d);
          this.dialogVisible = false;
        })
        .catch(e => {
          this.$dialog.alert(this.$t('newBook.saveError', { error: e.message }));
        })
        .finally(() => {
          this.saving = false;
        });
    }
  },
  computed: {
    feedback() {
      let fb = '';
      console.log(this.$v.bookName);
      if (!this.$v.bookName.required) {
        fb += this.$t('newBook.errors.nameRequired');
      }
      if (!this.$v.bookName.maxLength) {
        fb += this.$t('newBook.errors.nameTooLong', { maxchars: this.$v.bookName.$params.maxLength.max });
      }
      if (!this.$v.bookName.bookValidator) {
        fb += this.$t('newBook.errors.nameExists');
      }
      return fb;
    }
  }
};
</script>

<style scoped>
    button {
        margin-left: 0.3em;
    }
</style>
